// Build a clean, human-readable one-line preview from an email body.
// Strips <style>/<script>/<head> blocks (whose CSS/JS text would otherwise
// leak into the preview, e.g. "body,table,td,a{ -webkit-text-size-adjust… }"),
// then removes tags, decodes common entities, and collapses whitespace.
export function previewText(source) {
  if (!source) return '';
  let text = String(source);
  text = text
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<head[\s\S]*?<\/head>/gi, ' ')
    .replace(/<!--[\s\S]*?-->/g, ' ')
    // Any leftover CSS rule blocks (selector { ... }) even without <style> tags.
    .replace(/@media[^{]*\{[\s\S]*?\}\s*\}/gi, ' ')
    .replace(/[^{}<>]{1,80}\{[^{}]*\}/g, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/\s+/g, ' ')
    .trim();
  return text;
}
